import { render, staticRenderFns } from "./SelectLocality.vue?vue&type=template&id=36b91f3a&scoped=true"
import script from "./SelectLocality.vue?vue&type=script&lang=js"
export * from "./SelectLocality.vue?vue&type=script&lang=js"
import style0 from "./SelectLocality.vue?vue&type=style&index=0&id=36b91f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b91f3a",
  null
  
)

export default component.exports